import { defineStore } from 'pinia';
import state from './state.js';
import actions from './actions.js';

export const useInterAccountLeadsStore = defineStore({
    id: 'interAccountLeads',
    state() {
        return state;
    },
    actions,
});
